import api from './api';

export interface CategoryImage {
    filename: string;
    url: string;
    size: number;
    lastModified: string;
}

export interface CategoryWithImage {
    id: number;
    name: string;
    description?: string;
    image_url?: string;
    is_active: boolean;
    created_at: string;
    updated_at: string;
    s3_image?: CategoryImage | null;
    has_s3_image: boolean;
}

export interface CategoryUploadResponse {
    success: boolean;
    message: string;
    image?: {
        filename: string;
        url: string;
        categoryId: number;
        categoryName: string;
    };
}

export interface CategoriesResponse {
    success: boolean;
    categories: CategoryWithImage[];
}

export const categoryService = {
    // Get all categories with admin details (admin only)
    getCategoriesAdmin: async (): Promise<CategoriesResponse> => {
        try {
            const response = await api.get('/categories/admin');
            return response.data;
        } catch (error: any) {
            console.error('Erreur récupération catégories admin:', error);
            throw new Error(error.response?.data?.message || 'Erreur lors de la récupération des catégories');
        }
    },

    // Upload category image
    uploadCategoryImage: async (categoryId: number, imageFile: File): Promise<CategoryUploadResponse> => {
        try {
            const formData = new FormData();
            formData.append('image', imageFile);
            formData.append('categoryId', categoryId.toString());

            const response = await api.post('/categories/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });

            return response.data;
        } catch (error: any) {
            console.error('Erreur upload image catégorie:', error);
            throw new Error(error.response?.data?.message || 'Erreur lors de l\'upload de l\'image');
        }
    },

    // Delete category image
    deleteCategoryImage: async (categoryId: number): Promise<{ success: boolean; message: string }> => {
        try {
            const response = await api.delete(`/categories/${categoryId}/image`);
            return response.data;
        } catch (error: any) {
            console.error('Erreur suppression image catégorie:', error);
            throw new Error(error.response?.data?.message || 'Erreur lors de la suppression de l\'image');
        }
    },

    // Update category
    updateCategory: async (
        categoryId: number,
        data: { name: string; description?: string }
    ): Promise<{ success: boolean; message: string }> => {
        try {
            const response = await api.put(`/categories/${categoryId}`, data);
            return response.data;
        } catch (error: any) {
            console.error('Erreur mise à jour catégorie:', error);
            throw new Error(error.response?.data?.message || 'Erreur lors de la mise à jour de la catégorie');
        }
    }
};
